module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane fade show active",
    attrs: {
      "id": "nav-5-3-primary-ver--1",
      "role": "tabpanel"
    }
  }, [_c('span', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        return _vm.toggleCollapse(_vm.collapseStatus)
      }
    }
  }, [(_vm.collapseStatus == false) ? _c('a', {
    staticClass: "g-font-size-12"
  }, [_vm._v("Expand All ")]) : _vm._e(), (_vm.collapseStatus == true) ? _c('a', {
    staticClass: "g-font-size-12"
  }, [_vm._v("Collapse All")]) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticClass: "g-color-main"
  }, [_vm._v("Order")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#26304d",
      "height": "3px",
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _vm._l((_vm.groups), function(group, index) {
    return _c('div', {
      staticClass: "u-accordion u-accordion-color-primary",
      attrs: {
        "id": "accordion-12-1",
        "role": "tablist",
        "aria-multiselectable": "true"
      }
    }, [_c('div', {
      staticClass: "card g-brd-none rounded-0",
      class: {
        'g-bg-secondary': ((index % 2) == 1)
      }
    }, [_c('div', {
      staticClass: "u-accordion__header g-color-text g-font-weight-500",
      attrs: {
        "id": "accordion-12-1-heading-01",
        "role": "tab"
      }
    }, [_c('h5', {
      staticClass: "mb-0"
    }, [_c('a', {
      staticClass: "d-block g-color-text g-font-size-20--md g-font-size-17 g-color-primary--hover g-text-underline--none--hover g-pa-12",
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#accordion-12-1",
        "aria-expanded": "true",
        "aria-controls": "accordion-12-1-body-01"
      },
      on: {
        "click": function($event) {
          return _vm.changeCollapse(group)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(group.name) + "\n              ")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (group.open),
        expression: "group.open"
      }],
      staticClass: "collapsed show",
      attrs: {
        "id": "accordion-12-1-body-01",
        "role": "tabpanel",
        "aria-labelledby": "accordion-12-1-heading-01"
      }
    }, [_c('div', {
      staticClass: "u-accordion__body g-color-text g-pa-30 g-pt-0"
    }, [_c('span', {
      staticClass: "g-font-size-20--md g-font-size-17",
      domProps: {
        "innerHTML": _vm._s(group.items)
      }
    })])])])])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-869b70fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-869b70fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/helpData/helpList/Order.vue
// module id = 550
// module chunks = 4